import { isEmpty } from "lodash";

const TOKEN_KEY = "jwtToken";
const USER_INFO = "userInfo";

const parse = JSON.parse;
const stringify = JSON.stringify;

export const isBrowser = () => typeof window !== "undefined";

const auth = {
  /**
   * Remove an item from the used storage
   * @param  {String} key [description]
   */
  clear(key) {
    if (
      isBrowser() &&
      window.localStorage &&
      window.localStorage.getItem(key)
    ) {
      return window.localStorage.removeItem(key);
    }

    if (
      isBrowser() &&
      window.sessionStorage &&
      window.sessionStorage.getItem(key)
    ) {
      return window.sessionStorage.removeItem(key);
    }

    return null;
  },

  /**
   * Clear all app storage
   */
  clearAppStorage() {
    if (isBrowser() && window.localStorage) {
      window.localStorage.clear();
    }

    if (isBrowser() && window.sessionStorage) {
      window.sessionStorage.clear();
    }
  },

  clearToken(tokenKey = TOKEN_KEY) {
    return auth.clear(tokenKey);
  },

  clearUserInfo(userInfo = USER_INFO) {
    return auth.clear(userInfo);
  },

  /**
   * Returns data from storage
   * @param  {String} key Item to get from the storage
   * @return {String|Object}     Data from the storage
   */
  get(key) {
    if (
      isBrowser() &&
      window.localStorage &&
      window.localStorage.getItem(key)
    ) {
      return parse(window.localStorage.getItem(key)) || null;
    }

    if (
      isBrowser() &&
      window.sessionStorage &&
      window.sessionStorage.getItem(key)
    ) {
      return parse(window.sessionStorage.getItem(key)) || null;
    }

    return null;
  },

  getToken(tokenKey = TOKEN_KEY) {
    return auth.get(tokenKey);
  },

  getUserInfo(userInfo = USER_INFO) {
    return auth.get(userInfo);
  },

  /**
   * Set data in storage
   * @param {String|Object}  value    The data to store
   * @param {String}  key
   * @param {Boolean} isLocalStorage  Defines if we need to store in localStorage or sessionStorage
   */
  set(value, key, isLocalStorage) {
    if (isEmpty(value)) {
      return null;
    }

    if (isBrowser() && isLocalStorage && window.localStorage) {
      return window.localStorage.setItem(key, stringify(value));
    }

    if (isBrowser() && window.sessionStorage) {
      return window.sessionStorage.setItem(key, stringify(value));
    }

    return null;
  },

  setToken(value = "", isLocalStorage = false, tokenKey = TOKEN_KEY) {
    return auth.set(value, tokenKey, isLocalStorage);
  },

  setUserInfo(value = "", isLocalStorage = false, userInfo = USER_INFO) {
    return auth.set(value, userInfo, isLocalStorage);
  },
};

export default auth;
